import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './ProductNotFound.css';
import image1 from '../images/image 82.svg';

const ProductNotFound = () => {
  const { getText } = useLanguage();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const duration = 6000;
    const intervalTime = 100;
    const step = (intervalTime / duration) * 100;

    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + step));
    }, intervalTime);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      const timeout = setTimeout(() => navigate('/services'), 500);
      return () => clearTimeout(timeout);
    }
  }, [progress, navigate]);

  return (
      <div className="pnf-container">
        <main className="pnf-main">
          <div className="pnf-text-block">
            <h1 className="pnf-title">{getText('Груз не поступил', 'Маҳсулот ворид нашудааст')}</h1>
            <p className="pnf-subtitle">
              {getText('В настоящее время ваших товаров нет на складе', 'Дар айни замон молҳои шумо дар анбор нест')}<br />
              {getText('Возможно, они еще обрабатываются', 'Эҳтимол, онҳо ҳанӯз коркард мешаванд')}
            </p>
          </div>

          <div className="pnf-image-group">
            <div className="pnf-glow-circle"></div>
            <img src={image1} alt="No Cargo" className="pnf-main-img" />
          </div>
        </main>

        <div className="progress-footer">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
  );
};

export default ProductNotFound;